export default {
  version: 0.1,
  timeout: 60000,
  apiPrefix: "",
  cookiesExpires: 7,
  requestRetry: 4,
  requestRetryDelay: 800,
  tokenKey: 'JKCYXT_ACCESS_TOKEN',
  userInfoKey: 'JKCYXT_USER_INFO',
  permissionsKey:'JKCYXT_PERMISSION_ARRAY',
  emptyPlaceholder:'--',
  pageSizesArr:[10, 20,50,100,200],
  ossUrl:'https://jkhhtest-pic.oss-cn-beijing.aliyuncs.com/',//附件前缀
}
